import MomentUtils from '@date-io/moment';
import {
  Button,
  Chip,
  IconButton,
  Tab,
  Tabs,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { FormControl } from '@mui/material';
import { Close } from '@material-ui/icons';
import CancelIcon from '@material-ui/icons/Cancel';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ChipInput from 'material-ui-chip-input';
import MuiPhoneNumber from 'material-ui-phone-number';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Countries } from '../../../../constants/Countries';
import { currencies } from '../../../../constants/Currencies';
import { SuggestedHotelFeatures } from '../../../../constants/FeaturesConst';
import {
  ASSET_HOTELS,
  ASSET_TYPE_DOC,
  HOTEL_INFO_TYPES,
  Interests,
  StarRatings,
  TravelTypes,
  WC_MESSAGE_STATUS,
} from '../../../../constants/PropertyConst';
import ContactInformation from '../../../../shared/contact-information/ContactInformation';
import CustomMultiSelect from '../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomUpload from '../../../../shared/form-controls/custom-upload/Custom-Upload';
import CustomCheckbox from '../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import LocationInput from '../../../../shared/google-location-input/LocationInput';
import LocationMap from '../../../../shared/google-map/LocationMap';
import { getProcessedImages } from '../../../../shared/image-upload/ImageProcessor';
import ImageUpload from '../../../../shared/image-upload/ImageUpload';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import {
  formDataValidate,
  handleValidation,
  validateAlphanumeric,
} from '../../../../utils/formUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import {
  createNewHotel,
  getAllTimeZoneList,
  updateHotelDetails,
} from '../../../../utils/PropertyAPIUtils';
import {
  allBrandsSelector,
  allGroupsSelector,
  fetchAllProperties,
  selectedBrandSelector,
  selectedGroupSelector,
} from '../../propertySlice';
import './Hotel-Create.scss';
import ImagePicker from '../../../../shared/ui-builder/image-picker/Image-Picker';
import KeyValuePairList from '../../../../shared/key-value-pair-list/KeyValuePairList';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepUpLoaderCount, stepDownLoaderCount } from '../../../../utils/loaderSlice';
import { MAX_PDF_SIZE } from '../../../../utils/Constants';
import {
  decodeMediaKeyValue,
  renderVideos,
  renderGifs,
  toMediaContent,
  uploadGifToCMS,
  processGifsForUpload,
} from '../../../../utils/mediaUtils';

const HotelCreate = (props) => {
  const { toggleDrawer, hotel, showLoader = () => {} } = props;

  const lstGroup = useSelector(allGroupsSelector);
  const lstBrand = useSelector(allBrandsSelector);
  const hotelId = hotel?.id;
  const [filteredBrands, setFilteredBrands] = useState([]);
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [wcRawImages, setWcRawImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const selectedGroup = useSelector(selectedGroupSelector);
  const selectedBrand = useSelector(selectedBrandSelector);
  const [contactInfoList, setContactInfoList] = useState([]);
  const [rawVideos, setRawVideos] = useState([]);
  const [rawGifs, setRawGifs] = useState([]);
  const [videoImageUrl, setVideoImageUrl] = useState('');
  const [gifImageUrl, setGifImageUrl] = useState('');
  const [hasVideoError, setHasVideoError] = useState(false);
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isGifLoading, setIsGifLoading] = useState(false);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    groupId: {
      value: '',
      fieldName: 'Hotel Group',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    brandId: {
      value: '',
      fieldName: 'Brand',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Hotel Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Hotel Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    checkInTime: {
      value: '08:00',
      fieldName: 'Check-In Time',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 0,
    },
    checkOutTime: {
      value: '12:00',
      fieldName: 'Check-Out Time',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 0,
    },
    currency: {
      value: '',
      fieldName: 'Currency',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    phoneNumber: {
      value: '',
      fieldName: 'Phone Number',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    interests: {
      value: [],
      fieldName: 'Interests',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    travelType: {
      value: [],
      fieldName: 'Travel Type',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    starRating: {
      value: '',
      fieldName: 'Star Rating',
      errors: {},
      validations: [],
      tab: 0,
    },
    detailsCustomAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
    addressLine1: {
      value: '',
      fieldName: 'Address Line 1',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    addressLine2: {
      value: '',
      fieldName: 'Address Line 2',
      errors: {},
      validations: [],
      tab: 1,
    },
    country: {
      value: '',
      fieldName: 'Country',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    state: {
      value: '',
      fieldName: 'State',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    postalCode: {
      value: '',
      fieldName: 'Postal Code',
      errors: {},
      validations: [],
      tab: 1,
    },
    city: {
      value: '',
      fieldName: 'City',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    latitude: {
      value: '',
      fieldName: 'Latitude',
      errors: {},
      validations: [],
      tab: 1,
    },
    longitude: {
      value: '',
      fieldName: 'Longitude',
      errors: {},
      validations: [],
      tab: 1,
    },
    timezone: {
      value: '',
      fieldName: 'Timezone',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    area: {
      value: '',
      fieldName: 'Area',
      errors: {},
      validations: ['required'],
      placeholder: '(Ex: Downtown Avenue)',
      tab: 1,
    },
    covid19Regulations: {
      value: { url: '', type: '', name: '' },
      fieldName: 'COVID-19 Rules & Regulations',
      errors: {},
      validations: ['required', 'validIfUrl', 'safeURL', 'safeDomain'],
      tab: 2,
    },
    termsAndConditions: {
      value: { url: '', type: '', name: '' },
      fieldName: 'Terms & Conditions',
      errors: {},
      validations: ['required', 'validIfUrl', 'safeURL', 'safeDomain'],
      tab: 2,
    },
    cancellationPolicy: {
      value: { url: '', type: '', name: '' },
      fieldName: 'Cancellation Policy',
      errors: {},
      validations: ['required', 'validIfUrl', 'safeURL', 'safeDomain'],
      tab: 2,
    },
    dataProtection: {
      value: { url: '', type: '', name: '' },
      fieldName: 'Data Protection',
      errors: {},
      validations: ['required', 'validIfUrl', 'safeURL', 'safeDomain'],
      tab: 2,
    },
    privacyLaws: {
      value: { url: '', type: '', name: '' },
      fieldName: 'Privacy Laws',
      errors: {},
      validations: ['required', 'validIfUrl', 'safeURL', 'safeDomain'],
      tab: 2,
    },
    informationCustomAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 3,
    },

    features: {
      value: [],
      fieldName: 'Highlight features',
      errors: {},
      validations: ['maxLimit'],
      maxLimit: 5,
      ignoreValidationOnSubmit: true,
      tab: 4,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 6,
    },
    isWCMessageEnabled: {
      value: 'Inactive',
      fieldName: 'isWCMessageEnabled',
      errors: {},
      validations: [],
      tab: 5,
    },
    deviceTv: {
      value: false,
      fieldName: 'TV',
      errors: {},
      validations: [],
      tab: 5,
    },
    deviceTablet: {
      value: false,
      fieldName: 'Tablet',
      errors: {},
      validations: [],
      tab: 5,
    },
    messageText: {
      value: '',
      fieldName: 'Message Text',
      errors: {},
      validations: ['maxLength', 'required'],
      maxLength: 1000,
      tab: 5,
    },
    isSignatureEnabled: {
      value: 'Inactive',
      fieldName: '',
      errors: {},
      validations: [],
      tab: 5,
    },
    signatureTitle: {
      value: '',
      fieldName: 'Signature Title',
      errors: {},
      validations: [],
      tab: 5,
    },
    signatureImage: {
      value: '',
      fieldName: '',
      errors: {},
      validations: ['required'],
      tab: 5,
    },
    isImagesEnabled: {
      value: 'Inactive',
      fieldName: '',
      errors: {},
      validations: [],
      tab: 5,
    },
    wcImages: {
      value: '',
      fieldName: '',
      errors: {},
      validations: ['required'],
      tab: 5,
    },
    video: {
      value: '',
      fieldName: 'Paste Link',
      errors: {},
      validations: ['validUrl', 'safeDomain'],
      tab: 5,
    },
  });
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [timeZoneList, setTimeZoneList] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await getAllTimeZoneList();
        if (res?.data?.getTimeZones) {
          setTimeZoneList(res?.data?.getTimeZones);
        }
      } catch (e) {
        if (e.errors) {
          notificationManager('danger', e.errors[0].message);
        }
      }
    })();
  }, []);

  useEffect(() => {
    const currFields = { ...formData };
    if (hotel) {
      for (let field in hotel) {
        if (field === 'location') {
          for (let locField in hotel.location) {
            currFields[locField].value = hotel.location[locField] || '';
          }
        } else if (currFields.hasOwnProperty(field)) {
          currFields[field].value = hotel[field];
        }
      }
      setContactInfoList(hotel.information || []);
      currFields.images.value = hotel.images || [];
      currFields.features.value = hotel.features || [];
      currFields.detailsCustomAttributes.value = hotel.detailsCustomAttributes || [];
      currFields.informationCustomAttributes.value = hotel.informationCustomAttributes || [];

      currFields.isWCMessageEnabled.value = hotel.wcMessage.isWCMessageEnabled
        ? 'Active'
        : 'Inactive';
      currFields.messageText.value = hotel.wcMessage.messageText || '';
      currFields.deviceTv.value = hotel.wcMessage.device.tv;
      currFields.deviceTablet.value = hotel.wcMessage.device.tablet;
      currFields.isSignatureEnabled.value = hotel.wcMessage.signature.isSignatureEnabled
        ? 'Active'
        : 'Inactive';
      currFields.signatureTitle.value = hotel.wcMessage.signature.signatureTitle || '';
      currFields.signatureImage.value = hotel.wcMessage.signature.images || '';
      currFields.isImagesEnabled.value = hotel.wcMessage.isImagesEnabled ? 'Active' : 'Inactive';
      currFields.wcImages.value = hotel.wcMessage.images || '';
      currFields.video.value = hotel.wcMessage.video || '';
      currFields.detailsCustomAttributes.value = hotel.detailsCustomAttributes || [];
      currFields.informationCustomAttributes.value = hotel.informationCustomAttributes || [];
      setFormData(currFields);
      const { Video: videoMedia, GIF: gifMedia } = decodeMediaKeyValue(hotel?.mediaContent);
      const videoData = videoMedia || hotel?.videos || {};
      const gifData = gifMedia || hotel?.gifs || {};
      setVideoImageUrl(videoData?.imageUrl || '');
      setGifImageUrl(gifData?.imageUrl || '');
      setRawVideos(renderVideos(videoData));
      setRawGifs(renderGifs(gifData));
    } else {
      currFields.checkInTime.value = '08:00';
      currFields.checkOutTime.value = '12:00';
      setFormData(currFields);
    }
  }, [hotel]);

  useEffect(() => {
    if (lstBrand && formData.groupId.value) {
      setFilteredBrands(lstBrand.filter((brand) => brand.groupId === formData.groupId.value));
    }
  }, [formData.groupId.value, lstBrand]);

  useEffect(() => {
    if (!hotel && lstBrand.length && (selectedGroup || selectedBrand)) {
      const currGroupId =
        selectedGroup || lstBrand.find((brand) => brand.id === selectedBrand).groupId;
      const currField = { ...formData.groupId };
      currField.value = currGroupId;
      setFormData({ groupId: currField });
    }
  }, [hotel, selectedGroup, selectedBrand, lstBrand]);

  useEffect(() => {
    if (!hotel && filteredBrands.length && selectedBrand) {
      const currField = { ...formData.brandId };
      currField.value = selectedBrand;
      setFormData({ brandId: currField });
    }
  }, [hotel, filteredBrands, selectedBrand]);

  useEffect(() => {
    const messageText =
      formData.isWCMessageEnabled.value === 'Inactive'
        ? { ...formData.messageText, validations: [] }
        : { ...formData.messageText, validations: ['required', 'maxLength'] };

    setFormData({ messageText });
  }, [formData.isWCMessageEnabled.value]);

  useEffect(() => {
    const video =
      formData.video.value === ''
        ? { ...formData.video, validations: [] }
        : { ...formData.video, validations: ['validUrl', 'safeDomain'] };

    setFormData({ video });
  }, [formData.video.value]);

  useEffect(() => {
    const signatureImage =
      formData?.isSignatureEnabled?.value === WC_MESSAGE_STATUS[1] ||
      formData?.isWCMessageEnabled?.value === WC_MESSAGE_STATUS[1]
        ? { ...formData?.signatureImage, validations: [] }
        : { ...formData?.signatureImage, validations: ['required'] };

    setFormData({ signatureImage });
  }, [formData?.isSignatureEnabled?.value, formData?.isWCMessageEnabled?.value]);

  useEffect(() => {
    const wcImages =
      formData?.isWCMessageEnabled?.value === WC_MESSAGE_STATUS[1] ||
      formData?.isImagesEnabled?.value === WC_MESSAGE_STATUS[1]
        ? { ...formData?.wcImages, validations: [], value: [] }
        : {
            ...formData?.wcImages,
            validations: wcRawImages?.length === 0 ? ['required'] : [],
          };

    setFormData({ wcImages });
  }, [formData?.isWCMessageEnabled?.value, formData?.isImagesEnabled?.value, wcRawImages]);

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onWcImageListUpdated = (imgObjArr) => {
    setWcRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images];
    images.splice(index, 1);
    setFormData({ images });
  };

  const onUploadedWcImageRemoval = (index) => {
    const wcImages = [...formData.wcImages];
    wcImages.splice(index, 1);
    setFormData({ wcImages });
  };

  const handleTimePickerChange = (date, value, type) => {
    const currTimeField = { ...formData[type] };
    currTimeField.value = value;
    handleValidation(currTimeField);
    setFormData({
      [type]: currTimeField,
    });
  };

  const validate = (tabValue) => {
    const updatedFields = {};
    // If tabValue is given, filter out the form fields in current tab
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );

    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);

    return isValid;
  };

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  const onCancel = (e) => {
    toggleDrawer(false);
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
      return;
    }
    if (tabValue === 5 && newValue === 6 && isTabInValid) {
      return;
    }
    if (!isTabInValid) {
      setTabValue(newValue);
    }
  };

  const onLocationSelect = async (locObj) => {
    let addressLine1 = '';
    let addressLine2 = '';
    let country = '';
    let state = '';
    let postalCode = '';
    let city = '';
    const latitude = locObj.geometry.location.lat();
    const longitude = locObj.geometry.location.lng();
    /* this might be needed in the future */
    // let timezone = "";
    const currFormData = {
      ...formData,
    };

    locObj.address_components.forEach((item) => {
      if (item.types.includes('street_number')) {
        addressLine1 = item.long_name;
        return;
      }

      if (item.types.includes('route')) {
        addressLine1 += ` ${item.long_name}`;
        return;
      }

      if (item.types.includes('neighborhood') && item.types.includes('political')) {
        addressLine2 = item.long_name;
        return;
      }

      if (item.types.includes('country') && item.types.includes('political')) {
        country = item.long_name;
        return;
      }

      if (item.types.includes('administrative_area_level_1') && item.types.includes('political')) {
        state = item.long_name;
        return;
      }

      if (item.types.includes('postal_code')) {
        postalCode = item.long_name;
        return;
      }

      if (item.types.includes('locality') && item.types.includes('political')) {
        city = item.long_name;
      }
    });

    /* this might be needed in the future */
    // try {
    //   const timeInSecs = new Date().getTime() / 1000;
    //   const res = await axios.get(
    //     `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude}%2C${longitude}&timestamp=${timeInSecs}&key=AIzaSyAa_UAQQDPYFCyHvbDG4rlkxFYk1vgLFkM`
    //   );

    //   if (res.data && res.data.status === "OK" && res.data.timeZoneName) {
    //     timezone = res.data.timeZoneName;
    //   }
    // } catch (err) {
    //   console.error(err);
    // }

    currFormData.addressLine1.value = addressLine1 || locObj.vicinity;
    currFormData.addressLine2.value = addressLine2;
    currFormData.country.value = country;
    currFormData.state.value = state;
    currFormData.postalCode.value = postalCode;
    currFormData.city.value = city;
    currFormData.latitude.value = latitude;
    currFormData.longitude.value = longitude;
    /* this might be needed in the future */
    // currFormData.timezone.value = timezone;

    setFormData(currFormData);
    validate(1);
  };

  const handleSubmit = async (e) => {
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    e.preventDefault();

    if (validate(0) && validate(1) && validate(5)) {
      toggleDrawer('', false, '');
      const payload = {};

      for (let field in formData) {
        payload[field] = formData[field].value;
      }

      payload.information = contactInfoList.map((info, i) => {
        return { ...info, index: i };
      });

      const locationData = {
        addressLine1: formData.addressLine1.value,
        addressLine2: formData.addressLine2.value,
        country: formData.country.value,
        state: formData.state.value,
        postalCode: formData.postalCode.value,
        city: formData.city.value,
        latitude: formData.latitude.value,
        longitude: formData.longitude.value,
        timezone: formData.timezone.value,
        area: formData.area.value,
      };
      payload.location = locationData;

      if (!payload.covid19Regulations.url) {
        delete payload.covid19Regulations;
      }
      if (!payload.termsAndConditions.url) {
        delete payload.termsAndConditions;
      }
      if (!payload.cancellationPolicy.url) {
        delete payload.cancellationPolicy;
      }
      if (!payload.dataProtection.url) {
        delete payload.dataProtection;
      }
      if (!payload.privacyLaws.url) {
        delete payload.privacyLaws;
      }

      let wcMessage = {};
      wcMessage.isWCMessageEnabled = formData.isWCMessageEnabled.value === 'Active' ? true : false;
      wcMessage.messageText = formData.messageText.value;
      wcMessage.device = {
        tablet: formData.deviceTablet.value,
        tv: formData.deviceTv.value,
      };
      wcMessage.signature = {
        isSignatureEnabled: formData.isSignatureEnabled.value === 'Active' ? true : false,
        signatureTitle: formData.signatureTitle.value,
        images: formData.signatureImage.value,
      };

      wcMessage.isImagesEnabled = formData.isImagesEnabled.value === 'Active' ? true : false;
      wcMessage.video = formData.video.value;

      try {
        dispatch(stepUpLoaderCount());
        // Process the image upload first and set the response to main payload
        payload.images = await getProcessedImages(
          rawImages,
          formData?.groupId?.value,
          ASSET_HOTELS,
          hotelId,
        );

        payload.detailsCustomAttributes = formData.detailsCustomAttributes.value;
        payload.informationCustomAttributes = formData.informationCustomAttributes.value;
        if (wcRawImages?.length) {
          wcMessage.images = await getProcessedImages(
            wcRawImages,
            formData?.groupId?.value,
            ASSET_HOTELS,
            hotelId,
          );
        } else if (hotel) {
          wcMessage.images = formData?.wcImages?.value;
        }

        payload.WCMessageInput = wcMessage;
        payload.detailsCustomAttributes = formData.detailsCustomAttributes.value;
        payload.informationCustomAttributes = formData.informationCustomAttributes.value;
        const gifData = await processGifsForUpload({
          rawGifs,
          groupId: formData?.groupId?.value,
          propertyType: ASSET_HOTELS,
          hotelId,
        });

        payload.mediaContent = toMediaContent({
          videoList: rawVideos,
          videoImageUrl,
          gifList: gifData,
          gifImageUrl,
        });
        delete payload.deviceTablet;
        delete payload.deviceTv;
        delete payload.isImagesEnabled;
        delete payload.isSignatureEnabled;
        delete payload.isWCMessageEnabled;
        delete payload.messageText;
        delete payload.signatureImage;
        delete payload.signatureTitle;
        delete payload.video;
        delete payload.wcImages;

        if (hotel) {
          await updateHotelDetails(hotel.id, payload, language);
          notificationManager('success', 'Hotel updated successfully');
        } else {
          await createNewHotel(payload, language);
          notificationManager('success', 'Hotel created successfully');
        }

        dispatch(fetchAllProperties());
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          hotel
            ? notificationManager('danger', 'Hotel updation failed')
            : notificationManager('danger', 'Hotel creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Enter all required fields');

      if (!validate(0)) {
        setTabValue(0);
      }

      if (!validate(1)) {
        setTabValue(1);
      }
    }
  };

  const handleAddChip = (value) => {
    const currField = { ...formData }.features;
    const currFeatures = currField.value ? [...currField.value] : [];

    if (currFeatures.findIndex((c) => value === c) === -1) {
      handleValidation(currField);
      if (!handleValidation(currField)) {
        currFeatures.push(value);
      }
      currField.value = currFeatures;
      setFormData({ features: currField });
    }
  };

  const handleDeleteChip = (index) => {
    const currField = { ...formData.features };
    const tempFeature = [...currField.value];
    tempFeature.splice(index, 1);
    currField.errors = {};
    currField.value = tempFeature;
    setFormData({ features: currField });
  };

  const handlePhoneNoChange = (phone, country) => {
    const currField = { ...formData }.phoneNumber;
    currField.value = phone;

    handleValidation(currField);
    setFormData({ phoneNumber: currField });
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    let invalid = !isValid;
    if (tabValue === 0 && formData?.phoneNumber?.value.length < 9) {
      invalid = true;
    }
    if (tabValue === 5) {
      if (formData?.isWCMessageEnabled?.value !== 'Active') {
        invalid = false;
      } else {
        if (formData?.isSignatureEnabled?.value === 'Active') {
          if (!formData?.signatureImage?.value) {
            invalid = true;
          }
        }
        if (formData?.isImagesEnabled?.value === 'Active' && wcRawImages?.length === 0) {
          invalid = true;
        }
      }
    }
    setIsTabInValid(invalid);
  }, [formData, tabValue, wcRawImages]);

  const setErrorText = (type) => {
    if (formData[type].errors.required) return formData[type].errors.required;
    if (formData[type].errors.validTime) return formData[type].errors.validTime;
    return null;
  };

  const onChangePostalCode = (e) => {
    if (e.value) {
      const isValid = validateAlphanumeric(e.value);
      if (!isValid) return false;
    }
    setFormData({ postalCode: e });
  };

  const onChangeIsActive = (e) => {
    const isWCMessageEnabled = {
      value: e.target.value,
      fieldName: 'isWCMessageEnabled',
      validations: [],
      tab: 5,
    };
    setFormData({ isWCMessageEnabled });
  };

  const onChangeSignature = (e) => {
    const isSignatureEnabled = {
      value: e.target.value,
      fieldName: '',
      validations: [],
      tab: 5,
    };
    setFormData({ isSignatureEnabled });
  };

  const onChangeImageState = (e) => {
    const isImagesEnabled = {
      value: e.target.value,
      fieldName: '',
      validations: [],
      tab: 5,
    };
    setFormData({ isImagesEnabled });
  };

  const setImagesUrl = (e) => {
    const signatureImage = {
      value: e,
      fieldName: '',
      validations: [],
      errors: {},
      tab: 5,
    };
    setFormData({ signatureImage });
  };

  return (
    <form className='hotel-create' noValidate>
      <div className='container pt-4 d-flex align-items-end  flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-2'>
            <span className='page-title'>{hotel ? 'Edit Hotel' : 'Add Hotel'}</span>
          </div>
          <div className='col-md-9'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='hotel-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Location' />
              <Tab label='Documents' />
              <Tab label='Information' />
              <Tab label='Features' />
              <Tab label='WC Message' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll scroll-styled'>
          {tabValue === 0 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Hotel Details</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.groupId}
                    handleInputChange={(e) => {
                      setFormData({
                        groupId: e,
                        brandId: {
                          ...formData?.brandId,
                          value: '',
                        },
                      });
                    }}
                    labelPrefix='Select'
                    options={lstGroup}
                    hideNullOption={lstGroup.length}
                    shouldAppendCode={true}
                    addCodeToEnd={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    disabled={!formData.groupId.value}
                    item={formData.brandId}
                    handleInputChange={(e) => {
                      setFormData({ brandId: e });
                    }}
                    labelPrefix='Select'
                    options={filteredBrands}
                    hideNullOption={filteredBrands.length}
                    shouldAppendCode={true}
                    addCodeToEnd={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.name}
                    handleInputChange={(e) => {
                      setFormData({ name: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.code}
                    handleInputChange={(e) => {
                      setFormData({ code: e });
                    }}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.description}
                    handleInputChange={(e) => {
                      setFormData({ description: e });
                    }}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardTimePicker
                      variant='inline'
                      margin='normal'
                      id='checkin-time'
                      label='Check-In Time'
                      className='col-md-12'
                      ampm={false}
                      format='HH:mm'
                      inputValue={formData.checkInTime.value}
                      required={true}
                      onChange={(date, value) => handleTimePickerChange(date, value, 'checkInTime')}
                      error={
                        formData.checkInTime?.errors.required ||
                        formData.checkInTime?.errors.validTime
                          ? true
                          : false
                      }
                      helperText={setErrorText('checkInTime')}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className='col-md-6 mb-3'>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardTimePicker
                      className='col-md-12'
                      margin='normal'
                      id='checkout-time'
                      label='Check-Out Time'
                      format='HH:mm'
                      variant='inline'
                      required={true}
                      ampm={false}
                      inputValue={formData.checkOutTime.value}
                      onChange={(date, value) =>
                        handleTimePickerChange(date, value, 'checkOutTime')
                      }
                      error={
                        formData.checkOutTime?.errors.required ||
                        formData.checkOutTime?.errors.validTime
                          ? true
                          : false
                      }
                      helperText={setErrorText('checkOutTime')}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.currency}
                    handleInputChange={(e) => {
                      setFormData({ currency: e });
                    }}
                    labelPrefix='Select'
                    labelField='name'
                    valueField='code'
                    options={currencies}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <MuiPhoneNumber
                    name='phone'
                    label='Phone Number'
                    data-cy='user-phone'
                    defaultCountry={'in'}
                    required={true}
                    disableAreaCodes
                    autoFormat={true}
                    countryCodeEditable={false}
                    value={formData.phoneNumber.value}
                    className='col-md-12'
                    error={formData.phoneNumber.errors.required ? true : false}
                    helperText={formData.phoneNumber.errors.required}
                    onChange={(phone, country) => handlePhoneNoChange(phone, country)}
                    sx={{ '& svg': { height: '1.2rem' } }}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomMultiSelect
                    item={formData.travelType}
                    options={TravelTypes}
                    hideNullOption={true}
                    handleInputChange={(e) => {
                      setFormData({ travelType: e });
                    }}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomMultiSelect
                    item={formData.interests}
                    options={Interests}
                    hideNullOption={true}
                    handleInputChange={(e) => {
                      setFormData({ interests: e });
                    }}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    hideNullOption={true}
                    item={formData.starRating}
                    handleInputChange={(e) => {
                      setFormData({ starRating: e });
                    }}
                    options={StarRatings}
                  />
                </div>
                <div className='col-md-6 mb-3'></div>
              </div>
              <div className='row mt-4'>
                <KeyValuePairList
                  item={formData.detailsCustomAttributes}
                  onListChange={(e) => {
                    setFormData({ detailsCustomAttributes: e });
                  }}
                />
              </div>
            </div>
          )}
          {tabValue === 1 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Location</h4>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <LocationInput onLocationSelect={onLocationSelect} />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.addressLine1}
                    handleInputChange={(e) => {
                      setFormData({ addressLine1: e });
                    }}
                    maxLength='150'
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.addressLine2}
                    handleInputChange={(e) => {
                      setFormData({ addressLine2: e });
                    }}
                    maxLength='150'
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.country}
                    handleInputChange={(e) => {
                      setFormData({ country: e });
                    }}
                    labelField='name'
                    valueField='name'
                    labelPrefix='Select'
                    options={Countries}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.state}
                    handleInputChange={(e) => {
                      setFormData({ state: e });
                    }}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.postalCode}
                    handleInputChange={(e) => onChangePostalCode(e)}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.city}
                    handleInputChange={(e) => {
                      setFormData({ city: e });
                    }}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.latitude}
                    handleInputChange={(e) => {
                      setFormData({ latitude: e });
                    }}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.longitude}
                    handleInputChange={(e) => {
                      setFormData({ longitude: e });
                    }}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.area}
                    handleInputChange={(e) => {
                      setFormData({ area: e });
                    }}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.timezone}
                    handleInputChange={(e) => {
                      setFormData({ timezone: e });
                    }}
                    labelField='timeZone'
                    valueField='timeZone'
                    labelPrefix='Select'
                    options={timeZoneList}
                  />
                </div>
              </div>
              <div className='row'>
                <div
                  className={`col-md-12 ${
                    !(formData.latitude && formData.longitude) ? 'disabled-container' : ''
                  }`}
                >
                  <LocationMap lat={formData.latitude.value} lng={formData.longitude.value} />
                </div>
              </div>
            </div>
          )}
          {tabValue === 2 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>{formData.covid19Regulations.fieldName}</h4>
              <CustomUpload
                item={formData.covid19Regulations}
                hotelId={hotelId}
                additionalInput={{
                  type: ASSET_TYPE_DOC,
                  groupId: formData?.groupId?.value,
                  propertyType: ASSET_HOTELS,
                }}
                onUpload={(e) => {
                  setFormData({ covid19Regulations: e });
                }}
                maxFileSize={MAX_PDF_SIZE}
              />
              <h4 className='tab-title'>{formData.termsAndConditions.fieldName}</h4>

              <CustomUpload
                item={formData.termsAndConditions}
                hotelId={hotelId}
                additionalInput={{
                  type: ASSET_TYPE_DOC,
                  groupId: formData.groupId.value,
                  propertyType: ASSET_HOTELS,
                }}
                onUpload={(e) => {
                  setFormData({ termsAndConditions: e });
                }}
                maxFileSize={MAX_PDF_SIZE}
              />
              <h4 className='tab-title'>{formData.cancellationPolicy.fieldName}</h4>

              <CustomUpload
                item={formData.cancellationPolicy}
                hotelId={hotelId}
                additionalInput={{
                  type: ASSET_TYPE_DOC,
                  groupId: formData.groupId.value,
                  propertyType: ASSET_HOTELS,
                }}
                onUpload={(e) => {
                  setFormData({ cancellationPolicy: e });
                }}
                maxFileSize={MAX_PDF_SIZE}
              />
              <h4 className='tab-title'>{formData.dataProtection.fieldName}</h4>

              <CustomUpload
                item={formData.dataProtection}
                hotelId={hotelId}
                additionalInput={{
                  type: ASSET_TYPE_DOC,
                  groupId: formData.groupId.value,
                  propertyType: ASSET_HOTELS,
                }}
                onUpload={(e) => {
                  setFormData({ dataProtection: e });
                }}
                maxFileSize={MAX_PDF_SIZE}
              />
              <h4 className='tab-title'>{formData.privacyLaws.fieldName}</h4>

              <CustomUpload
                item={formData.privacyLaws}
                hotelId={hotelId}
                additionalInput={{
                  type: ASSET_TYPE_DOC,
                  groupId: formData.groupId.value,
                  propertyType: ASSET_HOTELS,
                }}
                onUpload={(e) => {
                  setFormData({ privacyLaws: e });
                }}
                maxFileSize={MAX_PDF_SIZE}
              />
            </div>
          )}
          {tabValue === 3 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Information</h4>
              <ContactInformation
                informationTypes={HOTEL_INFO_TYPES}
                setContactInfoList={setContactInfoList}
                contactInfoList={contactInfoList}
                infoFieldKey='field'
                infoValueKey='value'
              />
              <div className='row mt-4'>
                <KeyValuePairList
                  item={formData.informationCustomAttributes}
                  onListChange={(e) => {
                    setFormData({ informationCustomAttributes: e });
                  }}
                />
              </div>
            </div>
          )}
          {tabValue === 4 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Features</h4>
              <div className='row'>
                <div className='col-md-12 mb-3 d-flex align-items-center'>
                  <ChipInput
                    allowDuplicates={false}
                    value={formData.features.value}
                    onAdd={(chip) => handleAddChip(chip)}
                    label={formData.features.fieldName}
                    fullWidth
                    readOnly={true}
                    error={formData.features.errors.maxLimit ? true : false}
                    helperText={formData.features.errors.maxLimit}
                    chipRenderer={(
                      { value, isFocused, isDisabled, handleClick, handleRequestDelete },
                      key,
                    ) => (
                      <Chip
                        key={key}
                        variant='outlined'
                        color='primary'
                        className='me-2 custom-primary-chip'
                        label={value}
                        deleteIcon={<Close />}
                        onDelete={() => handleDeleteChip(key)}
                      ></Chip>
                    )}
                  />
                  <div className='gray-text'>
                    {formData.features.value?.length}/{formData.features.maxLimit}
                  </div>
                </div>
                <div className='col-md-12 mt-3 d-flex align-items-center'>
                  <div>
                    {SuggestedHotelFeatures.map((feature, i) => (
                      <Chip
                        key={i}
                        label={feature}
                        className='me-3 mb-2'
                        variant='outlined'
                        onClick={() => handleAddChip(feature)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
          {tabValue === 5 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Welcome Message</h4>
              <div className='d-flex justify-content-between'>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby='demo-radio-buttons-group-label'
                    defaultValue={formData.isWCMessageEnabled.value}
                    value={formData.isWCMessageEnabled.value}
                    name='radio-buttons-group'
                    onChange={(e) => onChangeIsActive(e)}
                  >
                    <div className='menu-active-status'>
                      <FormControlLabel
                        value='Active'
                        control={<Radio className='radio' />}
                        label='Active'
                        className='me-5'
                      />
                    </div>

                    <FormControlLabel value='Inactive' control={<Radio />} label='Inactive' />
                  </RadioGroup>
                </FormControl>
              </div>
              {formData.isWCMessageEnabled.value === 'Active' && (
                <>
                  <div className='sub-title mt-4 mb-1'>Devices </div>
                  <div className='d-flex'>
                    <div className='pe-5'>
                      <CustomCheckbox
                        item={formData.deviceTv}
                        handleInputChange={(e) => {
                          setFormData({ deviceTv: e });
                        }}
                        color='primary'
                      />
                    </div>
                    <div className='device-checkbox'>
                      <CustomCheckbox
                        item={formData.deviceTablet}
                        handleInputChange={(e) => {
                          setFormData({ deviceTablet: e });
                        }}
                        color='primary'
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-12 mb-3'>
                      <CustomTextField
                        item={formData.messageText}
                        handleInputChange={(e) => {
                          setFormData({ messageText: e });
                        }}
                        maxLength='1000'
                        multiline={true}
                        endAdornment={true}
                        characterCount={true}
                      />
                    </div>
                  </div>
                  <div className='sub-title mt-4 mb-1'>Signature </div>
                  <div className='d-flex justify-content-between'>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby='demo-radio-buttons-group-label'
                        defaultValue={formData.isSignatureEnabled.value}
                        value={formData.isSignatureEnabled.value}
                        name='radio-buttons-group'
                        onChange={(e) => onChangeSignature(e)}
                      >
                        <div className='menu-active-status'>
                          <FormControlLabel
                            value='Active'
                            control={<Radio className='radio' />}
                            label='Active'
                            className='me-5'
                          />
                        </div>

                        <FormControlLabel value='Inactive' control={<Radio />} label='Inactive' />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {formData.isSignatureEnabled.value === 'Active' && (
                    <>
                      <div className='col-md-6 mb-3'>
                        <CustomTextField
                          item={formData.signatureTitle}
                          handleInputChange={(e) => {
                            setFormData({ signatureTitle: e });
                          }}
                          maxLength={50}
                          endAdornment={true}
                          multiline={true}
                        />
                      </div>
                      <div className='col-md-6 mb-3'>
                        <ImagePicker
                          groupId={formData.groupId.value}
                          hotelId={hotelId}
                          titleH2={'Image'}
                          isCustomImage
                          onImageSelect={(e) => setImagesUrl(e)}
                          imgURL={formData.signatureImage.value}
                          error={formData.signatureImage.error}
                          format='PNG'
                        />
                      </div>
                    </>
                  )}

                  <div className='sub-title pt-4 mb-2'>Image </div>
                  <div className='d-flex justify-content-between'>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby='demo-radio-buttons-group-label'
                        defaultValue={formData.isImagesEnabled.value}
                        value={formData.isImagesEnabled.value}
                        name='radio-buttons-group'
                        onChange={(e) => onChangeImageState(e)}
                      >
                        <div className='menu-active-status'>
                          <FormControlLabel
                            value='Active'
                            control={<Radio className='radio' />}
                            label='Active'
                            className='me-5'
                          />
                        </div>

                        <FormControlLabel value='Inactive' control={<Radio />} label='Inactive' />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {formData.isImagesEnabled.value === 'Active' && (
                    <>
                      <div className='col-md-12 pt-4 mb-3'>
                        <ImageUpload
                          uploadedImages={formData.wcImages.value}
                          imgList={wcRawImages}
                          onImageListUpdated={onWcImageListUpdated}
                          onUploadedImageRemoval={onUploadedWcImageRemoval}
                          onImagesLoading={(status) => {
                            setLoading(status);
                          }}
                          isSingleImage
                          enabledMediaTabs={['image']}
                        />
                      </div>
                    </>
                  )}

                  <div className='row'>
                    <div className='sub-title pt-4'>Video </div>
                    <div className='col-md-12 mb-2'>
                      <CustomTextField
                        item={formData.video}
                        handleInputChange={(e) => {
                          setFormData({ video: e });
                        }}
                        endAdornment={true}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          {tabValue === 6 && (
            <div className='col-md-12 mb-3'>
              <ImageUpload
                uploadedImages={formData.images.value}
                imgList={rawImages}
                onImageListUpdated={onImageListUpdated}
                onUploadedImageRemoval={onUploadedImageRemoval}
                onImagesLoading={(status) => setLoading(status)}
                videoImageUrl={videoImageUrl}
                onVideoImageUrlChange={setVideoImageUrl}
                gifImageUrl={gifImageUrl}
                onGifImageUrlChange={setGifImageUrl}
                videoList={rawVideos}
                gifList={rawGifs}
                onVideoListUpdated={setRawVideos}
                onGifListUpdated={setRawGifs}
                hotelId={hotelId}
                groupId={formData?.groupId?.value}
                propertyType={ASSET_HOTELS}
                onVideoError={setHasVideoError}
                onThumbnailUploading={setIsThumbnailUploading}
                onVideoLoading={setIsVideoLoading}
                onGifLoading={setIsGifLoading}
              />
            </div>
          )}
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 6 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={isTabInValid || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading}
              >
                Next
              </Button>
            ) : (
              <Button
                disabled={loading || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading}
                variant='contained'
                onClick={handleSubmit}
                className='me-3'
                color='primary'
                size='large'
              >
                {hotel ?? hotel?.id ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              size='large'
              color='secondary'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && (
            <div className='pt-4 col-md-12'>
              <LinearProgressBar />
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default HotelCreate;
